module.exports = __webpack_public_path__ + "img/sac-lage-ipad.585aa4dc.png";